import { render, staticRenderFns } from "./MeasurementRow.vue?vue&type=template&id=f3cda286&scoped=true&"
import script from "./MeasurementRow.vue?vue&type=script&lang=js&"
export * from "./MeasurementRow.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementRow.vue?vue&type=style&index=0&id=f3cda286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cda286",
  null
  
)

export default component.exports